import React from 'react';

// ---- SectionHeader ----
// Reusable heading block used at the top of every section.
// Props:
//   tag    — small uppercase label (e.g. "What We Do")
//   title  — main heading, supports <em> for gold highlight
//   center — boolean, centers text (default: false)

const styles = {
  wrapper: (center) => ({
    marginBottom: '48px',
    textAlign: center ? 'center' : 'left',
  }),
  tag: {
    display: 'block',
    fontSize: '11px',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'var(--gold)',
    marginBottom: '12px',
    fontWeight: 500,
  },
  title: {
    fontFamily: 'var(--font-serif)',
    fontSize: 'clamp(28px, 4vw, 46px)',
    fontWeight: 700,
    lineHeight: 1.12,
    color: 'var(--text-primary)',
  },
};

export default function SectionHeader({ tag, title, center = false }) {
  return (
    <div style={styles.wrapper(center)}>
      {tag && <span style={styles.tag}>{tag}</span>}
      <h2
        style={styles.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </div>
  );
}
